var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 660,
    viewBox: "0 0 533 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 11.8125V648.256H520.959V121.229L411.543 11.8125H11.77Z",
    stroke: "black",
    strokeWidth: 22.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.543 11.8125L520.959 121.229H411.543V11.8125Z",
    stroke: "black",
    strokeWidth: 22.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.4 392.441H142.373L147.045 363.613H198.072L209.759 298.176H159.119L163.791 269.733H214.431L228.067 191.826H259.619L245.983 269.733H306.368L319.994 191.826H351.936L338.301 269.733H388.941L384.269 298.176H333.242L321.554 363.613H372.195L367.523 392.441H316.877L304.018 466.837H272.081L285.325 392.441H224.94L211.7 466.837H180.148L193.4 392.441ZM290.009 363.613L301.697 298.176H241.311L229.624 363.613H290.009Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageno);
export default __webpack_public_path__ + "static/media/pageno.ec88b5de74644bcee0dcd312e6e0b123.svg";
export { ForwardRef as ReactComponent };